import { FC } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Card,
  CardHeader,
  Grid,
  CardContent,
  CardActions,
  Button,
  Container,
} from '@mui/material';
import MyTooltip from './ToolTip';

interface CardTitleProps {
  heading?: string;
  subHeading?: string;
  onButtonClick?: () => void;
  buttonText: string;
  info: string;
}

const CustomCard: FC<CardTitleProps> = ({ heading, subHeading, onButtonClick, buttonText, info }) => {
  return (
    <Container sx={{ py: 2 }} maxWidth='lg'>
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '12px',
          boxShadow: 4,
        }}
      >
        <CardHeader
          title={
            <Grid
              container
              direction='row'
              justifyContent='space-between'
              alignItems='flex-start'
              spacing={1}
            >
              <Grid item>
                <Typography gutterBottom variant='h6' sx={{ fontWeight: 'bold' }}>
                  {heading}
                </Typography>
              </Grid>
              <Grid item>
                <MyTooltip message={info} />
              </Grid>
            </Grid>
          }
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Grid container direction='row' justifyContent='flex-start' alignItems='flex-start'>
            <Grid item>
              <Typography variant='body1'>{subHeading}</Typography>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container direction='row' justifyContent='flex-end' alignItems='flex-end'>
            <Grid item>
              <Button
                size='small'
                variant='contained'
                sx={{ textTransform: 'none' }}
                onClick={onButtonClick}
              >
                {buttonText}
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Container>
  );
};

CustomCard.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  onButtonClick: PropTypes.any,
};

export default CustomCard;
